import urls from "global/constants/UrlConstants";
import { WorkspaceQuota } from "types/workspace";
import { getCallParams, makeCall } from "utils/service";

export const fetchWorkspaceQuota = async (
  workspaceId: string,
): Promise<WorkspaceQuota> => {
  try {
    const callParams = await getCallParams("GET");
    const response: WorkspaceQuota = await makeCall(
      `${urls.WORKSPACE_BASE}/${workspaceId}/quota`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

/** Quotas of every workspace in the account that has one (account admin). */
export const fetchWorkspaceQuotas = async (): Promise<WorkspaceQuota[]> => {
  try {
    const callParams = await getCallParams("GET");
    const response: WorkspaceQuota[] = await makeCall(
      urls.WORKSPACE_QUOTA_FETCH,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const saveWorkspaceQuota = async (
  workspaceId: string,
  quota: number,
): Promise<WorkspaceQuota> => {
  try {
    const callParams = await getCallParams("PUT", { quota });
    const response: WorkspaceQuota = await makeCall(
      `${urls.WORKSPACE_BASE}/${workspaceId}/quota`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const removeWorkspaceQuota = async (workspaceId: string) => {
  try {
    const callParams = await getCallParams("DELETE");
    return await makeCall(
      `${urls.WORKSPACE_BASE}/${workspaceId}/quota`,
      callParams,
    );
  } catch (error: any) {
    throw error;
  }
};
